<template>
  <!-- start preloader -->
  <!-- <div class="preloader" id="preloader"></div> -->
  <!-- end preloader -->

  <!-- Scroll To Top Start-->
  <a href="javascript:void(0)" class="scrollToTop"><i class="fas fa-angle-double-up" /></a>
  <!-- Scroll To Top End -->


  <!-- Banner Section start -->
  <section class="banner-section index">
    <div class="overlay">
      <div class="banner-content">
        <div class="container wow fadeInUp">
          <div class="row justify-content-between align-items-center">
            <div>
              <Carousel v-bind="config">
                <Slide class="banner-item">
                  <div class="col-xl-6 col-lg-7 col-md-10">
                    <div class="main-content">
                      <div class="top-area section-text">
                        <h1 class="title">
                          Play <span>Online Casino</span> & Win Money Unlimited
                        </h1>
                        <p class="xlr">
                          PLAY CASINO AND EARN CRYPTO IN ONLINE. THE ULTIMATE ONLINE CASINO PLATFORM.
                        </p>
                        <div class="btn-area mt-30">
                          <a v-if="isAuthenticated" href="javascript:void(0)" data-bs-toggle="modal"
                            data-bs-target="#registerMod" class="cmn-btn reg !tw-px-6 !tw-py-[9px]"
                            @click="openPopup('login')">Play Now
                            <i class="icon-d-play" />
                          </a>
                          <a v-else href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#registerMod"
                            class="cmn-btn reg !tw-px-6 !tw-py-[9px]" @click="openPopup('register')">Sign Up
                            <i class="icon-d-right-arrow-2" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-5 col-md-2 col-12 banner-image-wrap">
                    <img src="../assets//images/banner/thumb.png" alt="casino">
                  </div>
                </Slide>
                <Slide class="single">
                  <div class="col-xl-6 col-lg-7 col-md-10">
                    <div class="main-content">
                      <div class="top-area section-text">
                        <h1 class="title">
                          Choose your <span>Welcome Bonus</span>
                        </h1>
                        <p class="xlr">
                          Up to €1,750 + 150 FS + 1 Bonus Crab in 3 bonuses
                        </p>
                        <div class="btn-area mt-30">
                          <a v-if="isAuthenticated" href="javascript:void(0)" data-bs-toggle="modal"
                            data-bs-target="#registerMod" class="cmn-btn reg !tw-px-6 !tw-py-[9px]"
                            @click="openPopup('login')">Play Now
                            <i class="icon-d-play" />
                          </a>
                          <a v-else href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#registerMod"
                            class="cmn-btn reg !tw-px-6 !tw-py-[9px]" @click="openPopup('register')">Sign Up
                            <i class="icon-d-right-arrow-2" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-5 col-md-2 col-12 banner-image-wrap">
                    <img src="../assets//images/banner/thumb1.png" alt="casino">
                  </div>
                </Slide>
                <Slide class="single">
                  <div class="col-xl-6 col-lg-7 col-md-10">
                    <div class="main-content">
                      <div class="top-area section-text">
                        <h1 class="title">
                          Get rich with <span>SWEET</span>
                        </h1>
                        <p class="xlr">
                          Play Sweet Bonanza NOW and get 100 $ bonus instantly
                        </p>
                        <h2 class="title">
                          Dont lose your CHANCE!
                        </h2>
                        <div class="btn-area mt-30">
                          <a v-if="isAuthenticated" href="javascript:void(0)" data-bs-toggle="modal"
                            data-bs-target="#registerMod" class="cmn-btn reg !tw-px-6 !tw-py-[9px]"
                            @click="openPopup('login')">Play Now
                            <i class="icon-d-play" />
                          </a>
                          <a v-else href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#registerMod"
                            class="cmn-btn reg !tw-px-6 !tw-py-[9px]" @click="openPopup('register')">Sign Up
                            <i class="icon-d-right-arrow-2" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-5 col-md-2 col-12 banner-image-wrap">
                    <img src="../assets//images/banner/thumb2.png" alt="casino">
                  </div>
                </Slide>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Banner Section end -->

  <HomeProviders />

  <HomeGameProviders />

  <!-- Popular Game start -->
  <HomePopularGames :games="allGames" />
  <!-- Popular Game end -->
</template>


<script>

import Const from '@/const'
import HomeProviders from '@/components/HomeProviders.vue';
import HomeGameProviders from '@/components/HomeGameProviders.vue';
//import HomePopularGames from '@/components/HomePopularGames.vue';
//import HomeJackpotGames from '@/components/HomeJackpotGames.vue';
import { allGames } from '@/sampleData';
import { usePopupStore } from '../stores/popup';
import { useAuthStore } from '../stores/authStore';
import { Carousel, Slide } from 'vue3-carousel';
import { computed, onBeforeUnmount, onMounted, reactive } from 'vue';

export default {
  name: 'HomePage',
  components: {
    HomeProviders,
    Carousel,
    Slide,
    HomeGameProviders
    //HomePopularGames,
    //HomeJackpotGames
  },
  setup() {
    const config = reactive({
      itemsToShow: 1,
      autoplay: 500,
      gap: 0,
      wrapAround: true, // Ensure looping of slides
      transition: 500, // Smooth transition effect
    });
  },
  data() {
    return {
      serverData: null, // Holds data fetched from the server
      allGames: allGames,
      welcomeBonusShowed: false
    };
  },
  computed: {
    // Access the isAuthenticated property from Pinia store
    isAuthenticated() {
      const authStore = useAuthStore();
      return authStore.isAuthenticated;
    }
  },
  unmounted() {
    window.removeEventListener('scroll', this.actionScroll);
  },
  created() {
    window.addEventListener('scroll', this.actionScroll);
  },
  mounted() {
    //this.fetchHomeCasino(); // Fetch data when the component is mounted

  },
  methods: {
    openPopup(popup) {
      const popupStore = usePopupStore();
      popupStore.showPopup(popup);
    },
    actionScroll() {
      const scroll = window.scrollY;
      if (scroll == 0 && this.welcomeBonusShowed == false) {
        // this.openPopup('welcome-bonus');
        // this.welcomeBonusShowed = true;
      }
    },
    async fetchHomeCasino() {
      const url = Const.URL;

      const headers = {
        'Accept': 'application/json, text/plain, */*',
        'Accept-Language': 'en-US,en;q=0.9,uk-UA;q=0.8,uk;q=0.7,pl;q=0.6',
        'Cache-Control': 'no-cache',
        'Connection': 'keep-alive',
        'Content-Type': 'application/json',
        'Cookie':
          'remember_web_59ba36addc2b2f9401580f014c7f58ea4e30989d=eyJpdiI6ImpnUDhDZWNhZmlwUnhJczdCdjY3cEE9PSIsInZhbHVlIjoiTXNqeWFqVm1UeXJjSEFMMm5wS3liajlWL2Z6QWQvZklBQldlNytpbGJWUmorSDhZWU1ZL21qRURCVUR3UW8yVTN5V0lFczB4cS90MVpYcDF6N2VRZjh0N1c2aitLb1FGSW1Xd3FpYzFTSkVqTUtuSVkvL04xMDR4NW9MRUtFM1d2SXc3T0lRMldLSndRQjVMSTlkcGxoTEpQM1NvUEFmRDZkcFV2RXE4d2Q5a3N0VUpMM09zOTY2dHIxZzVxWnM4Q3M5clFmTU1YLzZUM3pOU2xzY0plS1VMODNTN3Q3Ym9RbC90MnVlNHRzRT0iLCJtYWMiOiI4MjA5OGQxOWUzZGZlZGJkMzY3MGE4MmI4OTA2YzU5ZmQyZDllMzc1ZTgxYzUxMzA5NzgyOTgzNzcyM2M0ZGIzIn0%3D; XSRF-TOKEN=eyJpdiI6Ijl6a1pndjl5cVpucG1lSWluTFNUZFE9PSIsInZhbHVlIjoiRUJobyt3aENlUFEvczJ1SXJNWDRIbEx6RmdnYi8rUkpZM0lKRG1lMUdGeXEzSFRiYlhhK091cDJnc2pYZXI1K2pHY1l3Sm94YkR1eDVibGZ0TUFXM0hzKzlJR1lUTVdoNzhxT2NHMXpueGFQNVh6VEY2dkNWaTVDcHBCb1lwemciLCJtYWMiOiIwYjQ3ZmU2NGU2ZjFlZDY1NDIwMGQyYzFlMDdlYWFkM2YzN2QzNmNmNjA1MmYxNWMyYmVkOWMzNzU3ZDk4YjU5In0%3D; laravel_session=eyJpdiI6InN0UHFVTExkLzdwaU01cTNLVENldkE9PSIsInZhbHVlIjoiWDlsRk5nUnVWdTMzU1lKclllbG1KYXkxdkpHbEU5cXNPcGlBVks3ZGpBdmpRbFBiYVRhRWJRVC9RMjZ0N2xndTdlZndaZnRDdHNsOVBHWmVOUFgyallMWkNNQ0ZNNThHdldaTjliNUhhWWFxdUNWU0ZxVG84V3g1OWkrTWZ5c3IiLCJtYWMiOiIyYzk3ZWFiOWFiMzk4YjBiNmRkZWM4MGEzMmFhMzc5NTBjMjhjYTA3ZTE4YzAxMWE4YzRhYjRjNzVlMjY5YjJhIn0%3D',
        'DNT': '1',
        'Origin': 'https://azurecoinz.com',
        'Pragma': 'no-cache',
        'Referer': 'https://azurecoinz.com/home',
        'Sec-Fetch-Dest': 'empty',
        'Sec-Fetch-Mode': 'cors',
        'Sec-Fetch-Site': 'same-origin',
        'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36',
        'X-XSRF-TOKEN':
          'eyJpdiI6Ijl6a1pndjl5cVpucG1lSWluTFNUZFE9PSIsInZhbHVlIjoiRUJobyt3aENlUFEvczJ1SXJNWDRIbEx6RmdnYi8rUkpZM0lKRG1lMUdGeXEzSFRiYlhhK091cDJnc2pYZXI1K2pHY1l3Sm94YkR1eDVibGZ0TUFXM0hzKzlJR1lUTVdoNzhxT2NHMXpueGFQNVh6VEY2dkNWaTVDcHBCb1lwemciLCJtYWMiOiIwYjQ3ZmU2NGU2ZjFlZDY1NDIwMGQyYzFlMDdlYWFkM2YzN2QzNmNmNjA1MmYxNWMyYmVkOWMzNzU3ZDk4YjU5In0=',
        'sec-ch-ua': '"Google Chrome";v="131", "Chromium";v="131", "Not_A Brand";v="24"',
        'sec-ch-ua-mobile': '?0',
        'sec-ch-ua-platform': '"macOS"',
        'timeout': '10000',
      };

      const body = {};

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        this.serverData = data; // Update the component's state with the fetched data
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
  },
};
</script>

<style scoped>
.home {
  text-align: center;
  padding: 20px;
}

.banner-image-wrap {}

.banner-image-wrap img {
  overflow: clip;
  max-width: none;
  overflow-clip-margin: content-box;
  overflow: clip;
  max-height: 500px;
}

.banner-item .main-content {
  text-align: left;
}
</style>